import axios from 'axios';
import api from '@/lib/axios';
import { createProcurementAssistantApi } from './procurementAssistantRequests.js';

// History writes must not inherit the shared client's automatic POST retries.
const client = axios.create({
  baseURL: api.defaults.baseURL, withCredentials: true, timeout: 60000,
  headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
});
export const procurementAssistantApi = (context) => createProcurementAssistantApi(client, context);
